<template>

  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>Adjuntar Comprobante Pago</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>

      <v-container>
        <v-row>
          <v-flex
            sm12
            py-4
          >
            <span>Comprobante Pago</span>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs8
                align-center
                px-0
              >
                <span class="file-upload-input-box">
                  <span v-if="fileUpload.archivos.length > 0"> {{ fileUpload.archivos[0].name }} </span>
                  <span v-else-if="altaTurno.comprobante_pago"> {{ altaTurno.comprobante_pago }} </span>
                </span>
              </v-flex>
              <v-flex
                xs4
                align-center
                px-0
              >
                <vue-upload-component
                  :headers="fileUpload.headers"
                  :multiple="fileUpload.multiple"
                  ref="uploadOrden"
                  v-model="fileUpload.archivos"
                  :post-action="fileUpload.urlPost"
                  @input-file="subirOrden"
                  input-id="uploadOrden"
                  class=""
                >
                  <v-btn
                    color="secondary"
                    small
                    dark
                    :loading="subiendo"
                    class="v-btn--full ma-0"
                  >
                    Seleccionar
                  </v-btn>
                </vue-upload-component>
              </v-flex>

              <v-flex xs12>
                <span
                  v-if="fileUpload.error"
                  class="danger--text"
                >
                  Error: {{ fileUpload.error }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <botones-cancelar-guardar
          v-bind:mostrar-guardar="true"
          v-bind:guardando="guardando"
          v-on:alGuardar="guardarAdjunto"
          v-on:alCancelar="cerrar"
          v-if="!subiendo"
        ></botones-cancelar-guardar>

      </v-card-actions>
    </v-card-text>
  </v-card>
</template>
<script>
import mixinAbm from '@/mixins/abm'
import abmFormularioMixin from '@/mixins/abmFormulario'
import abmListadoMixin from '@/mixins/abmListado'
import VueUploadComponent from 'vue-upload-component'
import storageUtil from '@/helpers/storage'
import Agenda from '@/api/agenda'

export default {
  name: 'TurnoOrden',
  components: {
    VueUploadComponent
  },
  props: {
    agendaId: {
      type: Number,
      defualt: 0
    }
  },
  mixins: [mixinAbm, abmFormularioMixin, abmListadoMixin],
  computed: {
    configuracion () {
      return this.$store.getters.app
    },
    usuario () {
      return this.$store.getters.getUser
    },
    functionEvents () {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    }
  },
  data () {
    return {
      cargando: true,
      guardando: false,
      buscando: false,
      altaTurno: {
        observaciones: '',
        fecha_orden: null,
        comprobante_pago: null,
        paciente_id: null,
        id: null
      },
      fileUpload: {
        headers: {
          Authorization: null
        },
        multiple: false,
        archivos: [],
        mostrarBtnSubir: false,
        urlPost: null,
        error: null
      }
    }
  },
  mounted () {
    let vm = this
    let token = storageUtil.getKey('auth_token')
    vm.cargando = false
    vm.fileUpload.urlPost = Agenda.obtenerUrlSubirComprobantePago()
    vm.fileUpload.headers.Authorization = `Bearer ${token}`
  },
  methods: {
    guardarAdjunto () {
      let vm = this
      vm.altaTurno.id = vm.agendaId
      vm.guardando = true
      if (vm.altaTurno.comprobante_pago !== null) {
        Agenda.modificarComprobantePago(vm.altaTurno).then(
          data => {
            vm.mostrarMensajeOk()
            vm.guardando = false
            vm.cerrar()
          },
          error => {
            vm.guardando = false
            vm.mostrarError(error, true)
          }
        )
      } else {
        vm.guardando = false
        vm.mostrarError({ message: 'Por favor complete todos los campos' }, true)
      }
    },
    puedoGuardarEstudio () {
      return !this.subiendo
    },
    subirOrden (newFile, oldFile) {
      this.subirArchivo(newFile, oldFile, 'uploadOrden')
    },
    subirArchivo (newFile, oldFile, ref) {
      var vm = this
      var _ref = typeof ref !== 'undefined' ? ref : 'upload'

      if (newFile && newFile.active && !newFile.success) {
        vm.subiendo = true
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!vm.$refs[_ref].active) {
          vm.fileUpload.mostrarBtnSubir = true
          vm.fileUpload.error = null
          vm.subiendo = false
          vm.$refs[_ref].active = true
        }
      }

      if (newFile && oldFile) {
        if (newFile.success) {
          vm.altaTurno.comprobante_pago = newFile.response.file

          vm.$refs[_ref].clear()
          vm.fileUpload.mostrarBtnSubir = false
          vm.subiendo = false
          // onSuccess(newFile)
        }
        if (newFile.error) {
          switch (newFile.error) {
            case 'extension':
              vm.fileUpload.error = 'El archivo seleccionado debe ser .xlsx'
              break
            default:
              vm.fileUpload.error = newFile.error
              vm.$refs[_ref].clear()
              vm.fileUpload.mostrarBtnSubir = false
              break
          }

          vm.subiendo = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
dt {
  font-weight: 100;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.v-tabs__wrapper {
  background-color: #e41b23 !important;
}
.file-upload-input-box {
  border: 1px solid #e0e0e0;
  border-right: none;
  border-radius: 5px 0 0 5px;
  height: 28px;
  padding: 0 10px;
}
.v-btn--full {
  width: 100%;
  cursor: pointer !important;
}
h5 {
  padding-top: 20px;
}
.chips {
  padding-top: 15px;
}
.spinner {
  padding-top: 70px;
}
.blanco {
  color: #ffffff;
  font-weight: 100 !important;
}
.card {
  min-height: 180px;
}
.v-list {
  height: 300px !important; /* or any height you want */
  overflow-y: auto;
  z-index: 99999;
}
/* width */
::-webkit-scrollbar {
  width: 12px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
